import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!!_ctx.activeSettingsComponent && !!_ctx.defaultSettings)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeSettingsComponent), {
        key: 0,
        defaultSettings: _ctx.defaultSettings,
        "onUpdate:defaultSettings": _cache[1] || (_cache[1] = ($event: any) => (_ctx.defaultSettings = $event)),
        deviceName: _ctx.deviceName,
        readonly: _ctx.readonly
      }, null, 8, ["defaultSettings", "deviceName", "readonly"]))
    : _createCommentVNode("", true)
}